import {
  AccountHolder,
  AccountHolderTypeEnum as AccountTypeEnum,
} from "@rentablo/api/apiv1";
import { AccountHolderType, Values } from "../types";

export enum NaturalPersonsEnum {
  naturalPerson1 = "naturalPerson1",
  naturalPerson2 = "naturalPerson2",
  naturalPerson3 = "naturalPerson3",
}

export enum WizardTypeEnum {
  existingUser = "existingUser",
  newUser = "newUser",
}

export { AccountTypeEnum };

export interface CashbackWizardContext {
  accountHolders?: AccountHolder[];
  accountHolderType?: AccountHolderType;
  accountType: AccountTypeEnum;
  currentNaturalPerson: NaturalPersonsEnum;
  isNodeTransition: boolean;
  isAuthenticated: boolean;
  isEditing: boolean;
  subscriptionId: number;
  values: Values;
  wizardType: WizardTypeEnum;
  error?: string;
  externalRedirectUrl?: string;
}
